import { API_BASE } from '../utils/helpers';

const API_URL = `${API_BASE}/api/manicuristas`;

const actorHeaders = (actor) => {
  const headers = { 'Content-Type': 'application/json' };
  if (actor?.id) headers['X-User-Id'] = String(actor.id);
  if (actor?.role) headers['X-User-Role'] = String(actor.role);
  return headers;
};

const actorQuery = (actor) => {
  const params = new URLSearchParams();
  if (actor?.id) params.set('actorId', actor.id);
  if (actor?.role) params.set('actorRole', actor.role);
  const query = params.toString();
  return query ? `?${query}` : '';
};

const friendlyMessage = (message) => {
  const raw = String(message || '');
  if (/duplicate key|unique|UNIQUE KEY|Violation/i.test(raw)) {
    return 'Ya existe una manicurista con esos datos';
  }
  if (/String or binary data|truncated/i.test(raw)) {
    return 'Uno de los campos es demasiado largo';
  }
  if (/conversion failed|invalid|out-of-range/i.test(raw)) {
    return 'Revisa los datos ingresados e intenta nuevamente';
  }
  if (/<!DOCTYPE html>|<html/i.test(raw)) {
    return 'La ruta /api/manicuristas no esta disponible en el backend actual. Reinicia o despliega el backend actualizado.';
  }
  return raw || 'No se pudo completar la solicitud';
};

async function handle(res) {
  const text = await res.text().catch(() => '');
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {}

  if (!res.ok) {
    throw new Error(friendlyMessage(data?.error || data?.message || text || `Error HTTP ${res.status}`));
  }

  return data;
}

export async function obtenerManicuristas(actor = null) {
  const query = actorQuery(actor);
  const separator = query ? '&' : '?';
  const res = await fetch(`${API_URL}${query}${separator}_=${Date.now()}`, {
    headers: actorHeaders(actor),
    cache: 'no-store'
  });
  return handle(res);
}

export async function crearManicurista(payload, actor) {
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: actorHeaders(actor),
    body: JSON.stringify({ ...payload, ActorUsuarioId: actor?.id || null })
  });
  return handle(res);
}

export async function actualizarManicurista(id, payload, actor) {
  const res = await fetch(`${API_URL}/${id}`, {
    method: 'PUT',
    headers: actorHeaders(actor),
    body: JSON.stringify({ ...payload, ActorUsuarioId: actor?.id || null })
  });
  return handle(res);
}

export async function cambiarEstadoManicurista(id, activa, actor) {
  const res = await fetch(`${API_URL}/${id}/estado`, {
    method: 'PATCH',
    headers: actorHeaders(actor),
    body: JSON.stringify({ Activa: activa, ActorUsuarioId: actor?.id || null })
  });
  return handle(res);
}

export async function eliminarManicurista(id, actor) {
  const res = await fetch(`${API_URL}/${id}${actorQuery(actor)}`, {
    method: 'DELETE',
    headers: actorHeaders(actor)
  });
  return handle(res);
}
